// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4e6f274c]:export {\n  menuBg: #393997;\n  menuText: #fff;\n  menuActiveText: #409eff;\n}\n\n/* Mixins */\n.svg-icon[data-v-4e6f274c] {\n  vertical-align: middle;\n}\n.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}", ""]);
// Exports
module.exports = exports;
